import { MijnRoute } from '../../mijn-navigatie.model';

export const PAYMENT_REQUEST: MijnRoute = {
    path: 'betaalverzoek',
    navigationEvent: 'toBetaalverzoek',
    regex: /^\/betaalverzoek$/,
    webcomponent: 'mijn-betalen-betaalverzoek-webcomponent'
};
